import { Component } from '@angular/core';
import { SummaryWrapperBase} from '@app/wrappers/summary-wrapper-base';
import {environment} from '@root/src/environments/environment';

@Component({
  selector: 'msf-summary-wrapper',
  templateUrl: './summary-wrapper.html',
  styleUrl: './summary-wrapper.scss',
  standalone:false
})
export class SummaryWrapper extends  SummaryWrapperBase {
 readonly  client = environment.client ;

}
